import memberService from '../../services/MemberService';
import _ from 'lodash';
import {
  SportItemMap,
  BetTypeGroup,
  SportMarketMap,
  OUTRIGHT_TYPE,
  Mode,
  getEsportMarketName,
  getMarketName,
  getBetTypeGroup,
  SPORT,
  Market,
  LeftMenuHeaderGroup,
  ESportItemMap,
  getEsportMarketFromUrl
} from '../../common/Foundation';
import Constants from '../../common/Constants';
import Utils from '../../common/Utils';
import * as mobx from 'mobx';
import cookie from 'react-cookies'
import { EVENT } from '../../common/events/listEvents';

export default class LeftMenuAction {

  static async getSportsData(country, v) {
    return await memberService.getSportsMarkets(country, v).then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

  static async getPlaytechGames() {
    return await memberService.getPlaytechGames().then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

  /**
   * Call service get data for left menu
   * @param {*} country 
   * @param {*} v 
   */
  static async getAsiaSportsData(country, v) {
    return await memberService.getAsiaSportsMarkets(country, v).then(res => {
      return res.data;
    }).catch(e => {
      return null;
    });
  }

  /**
   * sort Sport priority for user after login
   * @param {*} sportsSorting 
   * @param {*} data 
   */
  static sortSportsPriority(sportsSorting, data) {
    if (sportsSorting && data) {
      data.sort(function (a, b) {
        let pa = sportsSorting.indexOf("," + a[0] + ",");
        let pb = sportsSorting.indexOf("," + b[0] + ",");
        if (pa < 0){
          pa = 9999;
        }
        if (pb < 0){
          pb = 9999;
        }
        return pa - pb;
      });
    }
  };

  static getLeftMenuHeaderGroupByUrl (url, supportProduct) {
    let urlArr = _.split(decodeURI(url), '/');
    if (urlArr.includes('esports') ||
      supportProduct === Constants.SUPPORT_PRODUCT_ONLY.ESPORTS)
    {
      return LeftMenuHeaderGroup.ESPORTS;
    } else if (urlArr.includes('inplay')){
      return LeftMenuHeaderGroup.INPLAY;
    } else if (urlArr.includes('live-casino')){
      return LeftMenuHeaderGroup.LIVE_CASINO;
    }  else if (urlArr.includes('casino')){
      return LeftMenuHeaderGroup.CASINO;
    } else if(urlArr.includes('Mix Parlay')) {
      return LeftMenuHeaderGroup.PARLAY;
    }else {
      return LeftMenuHeaderGroup.SPORTS;
    }
  }

  static getLeftHeaderPath (leftMenuHeaderGroup) {
    switch (leftMenuHeaderGroup) {
      case LeftMenuHeaderGroup.SPORTS:
        return Constants.LEFT_HEADER_PATH.SPORTS;
      case LeftMenuHeaderGroup.ESPORTS:
        return Constants.LEFT_HEADER_PATH.ESPORTS;
      case LeftMenuHeaderGroup.INPLAY:
        return Constants.LEFT_HEADER_PATH.INPLAY;
      case LeftMenuHeaderGroup.CASINO:
        return Constants.LEFT_HEADER_PATH.CASINO;
      default:
        return Constants.LEFT_HEADER_PATH.SPORTS;
    }
  }

  /**
   * combine data to set to url
   * @param {*} options 
   */
  static getRedirectToSportsUrl(options, leftMenuHeader) {
    if (!options) {
      return '';
    }
    let opt = mobx.toJS(options);
    let { mode, sportId, market, betTypeGroup, period } = opt;
    let isEsport = sportId == Constants.ESPORT_ID;
    let selectedMarket = isEsport ? getEsportMarketName(market) : getMarketName(market);
    let selectedBetType = getBetTypeGroup(betTypeGroup);
    let url;
    let sportName = SPORT(sportId, true);
    let leftHeaderPath = this.getLeftHeaderPath(leftMenuHeader);
    let root = '/' + Utils.getCurrentLang() + '/asian/' + leftHeaderPath + '/';
    if (mode == Mode.OUTRIGHT) {
      sportId = _.get(opt, 'outright.sportId');
      sportName = SPORT(sportId, true);
      url = 'outright/' + sportName
    } else if (isEsport) {
      let code = _.get(opt, 'eSports.eSportCode');
      code = (code === '' ? 'All Games' : code);
      if (leftMenuHeader === LeftMenuHeaderGroup.ESPORTS){
        url = [code, selectedMarket, selectedBetType, period].filter(item => item !== undefined).join('/')
      } else {
        url = [sportName, code, selectedMarket, selectedBetType, period].filter(item => item !== undefined).join('/')
      }
    } else {
      url = [sportName, selectedMarket, selectedBetType, period].filter(item => item !== undefined).join('/')
    }
    return root + url;
  }

  /**
   * Set value to Options when selecting sport on outright on Left menu
   * @param {*} options 
   * @param {*} sportId 
   */
  static updateOptionsForOutright(options, sportId, leagueIds, outrightType) {
    if (!leagueIds){
      leagueIds = [];
    }
    let opt = mobx.toJS(options);
    let optionsUpdate = {};
    let outright = _.get(opt, 'outright', {});
    let eSports = _.get(opt, 'eSports', {});
    optionsUpdate.sportId = Constants.OUTRIGHT_ID;
    optionsUpdate.sportName = '';
    outright.sportId = sportId;
    optionsUpdate.mode = Mode.OUTRIGHT;
    outright.outrightType = outrightType ? outrightType : OUTRIGHT_TYPE.OUTRIGHT;
    outright.leagueIds = leagueIds;
    eSports.eSportCode = '';
    optionsUpdate.outright = outright;
    optionsUpdate.eSports = eSports;
    optionsUpdate.market = Market.All;
    optionsUpdate.betTypeGroup = BetTypeGroup.OUTRIGHT;
    return optionsUpdate;
  }

  /**
   * Set value to Options when change Left menu Items
   * @param {*} options 
   * @param {*} optionsInput 
   */
  static changeBetTypeGroup(options, optionsInput) {
    const opt = mobx.toJS(options);
    let { isEsport, sportId, code, marketId, betTypeGroup, period, leagueIds , leftMenuHeaderGroup} = optionsInput;
    let { eSports, teaser, parlay, outright } = opt;

    if (!leagueIds) {
      leagueIds = [];
    }

    let optionsUpdate = {
      'sportId': sportId,
      'market': marketId,
      'betTypeGroup': betTypeGroup,
      'period': period,
    };

    if (_.isNumber(leftMenuHeaderGroup)) {
      optionsUpdate.leftMenuHeaderGroup = leftMenuHeaderGroup
    }

    let mode = opt.mode;
    let outrightType = outright.outrightType;
    switch (betTypeGroup) {
      case BetTypeGroup.DOUBLE_CHANCE:
        outrightType = OUTRIGHT_TYPE.DOUBLE_CHANCE;
        mode = Mode.OUTRIGHT_MARKET
        this.updateOutrightOptions(optionsUpdate, outright, sportId, outrightType, leagueIds);
        break;
      case BetTypeGroup.CORRECT_SCORE:
        outrightType = OUTRIGHT_TYPE.CORRECT_SCORE;
        mode = Mode.OUTRIGHT_MARKET
        this.updateOutrightOptions(optionsUpdate, outright, sportId, outrightType, leagueIds);
        break;
      case BetTypeGroup.SPECIAL:
        outrightType = OUTRIGHT_TYPE.SPECIAL;
        mode = Mode.OUTRIGHT_MARKET
        this.updateOutrightOptions(optionsUpdate, outright, sportId, outrightType, leagueIds);
        break;
      case BetTypeGroup.TEASERS:
        mode = Mode.TEASER_MARKET
        teaser.date = Utils.generateTodayDates(-240).value;
        teaser.leagueIds = leagueIds;
        teaser.sportId = sportId;
        optionsUpdate.teaser = teaser;
        break;
      case BetTypeGroup.MIX_PARLAY:
        parlay.date = marketId === Market.Today ? Utils.generateTodayDates(-240).value : '';
        parlay.leagueIds = leagueIds;
        mode = Mode.PARLAY_MARKET
        parlay.sportId = sportId;
        optionsUpdate.parlay = parlay;
        break;
      case BetTypeGroup.OUTRIGHT:
        mode = Mode.OUTRIGHT_MARKET
        outrightType = OUTRIGHT_TYPE.OUTRIGHT;
        this.updateOutrightOptions(optionsUpdate, outright, sportId, outrightType, leagueIds);
        break;
      default:
        mode = Mode.NORMAL
        optionsUpdate.leagueIds = leagueIds;
        optionsUpdate.eSports = {};
        break;
    }

    if (isEsport) {
      eSports.eSportId = sportId;
      eSports.eSportCode = code;
      eSports.eSportLeagueIds = leagueIds;
      optionsUpdate.eSports = eSports;
    }
    optionsUpdate.mode = mode;
    return optionsUpdate
  }

  /**
   * set value for options when selecting outright market
   */
  static updateOutrightOptions(optionsUpdate, outright, sportId, outrightType, leagueIds) {
    outright.outrightType = outrightType;
    outright.sportId = sportId;
    outright.leagueIds = leagueIds;
    optionsUpdate.outright = outright;
  }

  /**
   * commbine data to generate id on left menu item
   */
  static generateLeftMenuItemKey(sportId,
    code,
    market,
    betTypeGroup,
    period) {
    return [sportId, code, market, betTypeGroup, period].join('|');
  }

  static getInfoById(id) {
    let idarr = id.split('|');
    return {
      sportId: idarr[0],
      code: idarr[1],
      market: idarr[2],
      betTypeGroup: idarr[3],
      period: idarr[4]
    }
  }

  static getSelectedItemId(leftOptions) {
    const {
      sportId,
      market,
      betTypeGroup,
      period,
      code
    } = leftOptions;
    let id = [sportId, code, market, betTypeGroup, period].join('|')
    return id;
  }

  /**
 * commbine data to generate id on left menu item
 */
  static generateEsportBetTypeGroupKey(
    market,
    betTypeGroup,
    period) {
    return [market, betTypeGroup, period].join('|');
  }

  static getDefautSport(options, optionsInput) {
    const { sportId, sportName } = optionsInput;
    let isEsport = sportId === Constants.ESPORT_ID;
    optionsInput.isEsport = isEsport;
    let optionsUpdate = this.changeBetTypeGroup(options, optionsInput);
    optionsUpdate['sportId'] = sportId;
    optionsUpdate['sportName'] = sportName;

    return optionsUpdate;
  }

  static getDefaultEsport(options, optionsInput) {
    let isEsport = true;
    optionsInput.isEsport = isEsport;
    let optionsUpdate = this.changeBetTypeGroup(options, optionsInput);
    return optionsUpdate;
  }

  static getDefaultBetTypeGroup(betTypeGroups, market, betTypeGroupsUser) {
    if (!betTypeGroups || !betTypeGroups[market]) {
      return;
    }
    let defaultBetTypeGroup = _.find(betTypeGroups[market], item => {     
        return betTypeGroupsUser && item.betTypeGroup === betTypeGroupsUser && item.numberEvents > 0;            
    })
    if (_.isEmpty(defaultBetTypeGroup)) {
      defaultBetTypeGroup = _.find(betTypeGroups[market], item => {     
        return item.numberEvents > 0;            
      }) || {};
    }
    return defaultBetTypeGroup;
  }

  static updateOptionsForTournament(optionsInput) {
    let leagueIds = [];
    let {sportId, market, betTypeGroup, eSports, mode, outright, leagues} = optionsInput;
    if (mode === Mode.OUTRIGHT || mode === Mode.OUTRIGHT_MARKET){
      outright.leagueIds = leagues
    } else if (sportId === Constants.ESPORT_ID){
      eSports.eSportLeagueIds = leagues
    } else {
      leagueIds = leagues;
    }
    let optionsUpdate = {
      'sportId': sportId,
      'market': market,
      'betTypeGroup': betTypeGroup,
      'leagueIds': leagueIds,
      'eSports': eSports,
      'mode': mode,
      'outright': outright,
      'period': 0
    };
    return optionsUpdate
  }

  static updateFilterOptions(optionsUpdate, date) {
    let dates = Utils.generateDates(5, -240);
    let firstDate = Utils.generateDate(date, -240).value;
    let isExist = false;
    _.forEach(dates, function (dt, idx) {
      if (dt.value === firstDate) {
        isExist = true;
        return;
      }
    });
    let filterOptions = isExist ? { selectedDate: firstDate } : '';
    optionsUpdate.filterOptions = filterOptions;
  }

  static findSportDefault(sports, map, isLive, defaultSportId) {
    const defaultSport = _.find(sports, sport => {
      if (defaultSportId){
        return sport[SportMarketMap.id] == defaultSportId
      } else if (isLive) {
        return sport[SportMarketMap.live][map.totalEvents] > 0
      }
    })
    if (!defaultSport) {
      return sports[0];
    }
    return defaultSport;

  }

  static findESportFromUrl(esposrtFromUrl, parts) {
    const esportMarket = parseInt(getEsportMarketFromUrl(parts[6]));
    return _.get(esposrtFromUrl, [0, esportMarket, ESportItemMap.parlayEvents], 0);
  }

  static findESportDefault(sports, map, isLive) {
    return _.find(sports, sport => {
      if (isLive) {
        return sport[SportMarketMap.live][map.totalEvents] > 0
      }
      return sport[SportMarketMap.live][map.totalEvents] > 0 || sport[SportMarketMap.today_soon][map.totalEvents] ||
        sport[SportMarketMap.early_pregame][map.totalEvents] > 0
    })
  }

  static getDefaultBetypeGroupBySport(sport, map, isParlayHeaderTab) {
    if (!sport) {
      return BetTypeGroup.HDP_OU
    }
    if (isParlayHeaderTab) {
      return BetTypeGroup.MIX_PARLAY;
    }
    const betTypeSummary = sport[map.betTypeSummary];
    if (!_.isEmpty(betTypeSummary)) {
      for (let i = 0; i < betTypeSummary.length; i++) {
        const item = betTypeSummary[i];
        const itemName = _.get(item, '[1]');
        const itemCount = _.get(item, '[3]');
        if (itemCount > 0) {
          return BetTypeGroup[itemName];
        }
      }
    }
    if (sport[map.outrightEvents] > 0) {
      return BetTypeGroup.OUTRIGHT;
    }
    if (sport[map.correctScoreEvents] > 0) {
      return BetTypeGroup.CORRECT_SCORE;
    }
    if (sport[map.specialEvents] > 0) {
      return BetTypeGroup.SPECIAL;
    }
    return BetTypeGroup.HDP_OU;
  }

  /**
   * Get sport by sport nane.
   * @param sports 
   * @param sportName 
   */
  static getSportByName(sports, sportName) {
    if (sportName) {
      return _.find(sports, (sport) => {
        let result = sport[SportMarketMap.today_soon] ? sport[SportMarketMap.today_soon] : sport[SportMarketMap.early_pregame];
        return sportName.toLowerCase() === result[SportItemMap.name].toLowerCase();
      })
    }
  }

  /**
   * Call to TC page if isShowAcceptTC cookie is true.
   */
  static goToTCPage() {
    let activeFirstLogin = false;
    let isShowAcceptTC = cookie.load('isShowAcceptTC');
    if (isShowAcceptTC) {
        activeFirstLogin = JSON.parse(isShowAcceptTC);
    }
    if (activeFirstLogin) {
        window.fireEvent(EVENT.FIRST_LOGIN);
        return true
    }
    return false
  }
}


// WEBPACK FOOTER //
// ./src/app/components/LeftMenuComponent/LeftMenuAction.js